export default "__VITE_ASSET__50ad19d0__"